export default __webpack_public_path__ + "static/media/photo--lg--39.48433abd.jpg";